







//@ts-ignore
import store from "../../store";
import {Component, Prop, Vue} from "vue-property-decorator";
import type {
    AutomationPlayerMap,
    Player, PlayerAutomationStatus,
    PlayerRole
} from "../../../types";

@Component({

})

export default class PlayerStatusAndRole extends Vue {
    @Prop({required: true}) private player!: Player;

    private get currentPlayerId(): string
    {
        return store.getters.getPlayerId;
    }

    /**
     * Карта игроков автоматизации
     */
    private get playersMap(): {[key: string]: AutomationPlayerMap}|null
    {
        return store.getters.getPlayersAutomationMap;
    }

    /**
     * Роль игрока в автоматизации игры
     */
    private get playerRole(): PlayerRole|null
    {
        return store.getters.getPlayerAutomationRole(this.player.id);
    }

    /**
     * Статус игрока в автоматизации игры
     */
    private get playerStatus(): PlayerAutomationStatus|null
    {
        return store.getters.getPlayerAutomationStatus(this.player.id);
    }

    /**
     * Есть роль автоматизации
     */
    private get hasAutomationRole(): boolean
    {
        return !!this.playersMap && !!this.playerRole;
    }

    /**
     * Иконка роли
     */
    private get roleIcon(): string
    {
        if (this.hasAutomationRole && this.playerStatus) {
            if (this.playerStatus.value === 1) {
                return ''
            } else {
                return `/images/statuses/${this.playerStatus.icon}`;
            }
        }
        return '';
    }

    /**
     * Иконка роли
     */
    private get statusIcon(): string
    {
        if (this.playerRole && !this.playerRole.icon) {
            return '';
        }

        if (this.hasAutomationRole && this.playerRole) {
            if (!this.playerRole.visibleFor.length) {
                return `/images/roles/${this.playerRole.icon}`;
            }else if (this.playerRole.visibleFor.indexOf(this.currentPlayerId) === -1) {
                return ''
            } else {
                return `/images/roles/${this.playerRole.icon}`;
            }
        }
        return '';
    }
}
